import React from "react";

import { Tab as ATab, TabProps } from "@atlaskit/tabs";

export const Tab: React.FC<TabProps> = (props) => <ATab {...props} />;

export type { TabProps };
